/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { ContentEditableEvent } from 'react-contenteditable';
import { EditableField, FieldType, IEditProps } from './editable-fields/editable-field';

export { ContentEditableEvent };

export interface IVideoProps {
    className?: string;
    children: JSX.Element;
    editProps?: IEditProps;
    role?: string;
}

// eslint-disable-next-line jsdoc/require-jsdoc
export class Video extends React.Component<IVideoProps> {
    constructor(props: IVideoProps) {
        super(props);
    }

    public render = (): JSX.Element => {
        return (
            <EditableField
                editPropKey={this.props.editProps && this.props.editProps.key}
                requestContext={this.props.editProps && this.props.editProps.requestContext}
                fieldProps={{
                    className: this.props.className,
                    children: this.props.children,
                    role: this.props.role
                }}
                type={FieldType.Video}
            />
        );
    };
}
